<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Configuration.CustomTable'
}
</script>

<style scoped>

</style>
